"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _ProductListItemCard = _interopRequireDefault(require("@sprinx/react-com/ProductListItemCard"));

var _ProductListItemImage = _interopRequireDefault(require("@sprinx/react-com/ProductListItemImage"));

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _useCalculateProductPriceHandler = _interopRequireDefault(require("@sprinx/react-pricing/useCalculateProductPriceHandler"));

var _ProductListItemDetailLink = _interopRequireDefault(require("../ProductListItemDetailLink"));

var _ProductListItemCardAddToCartButton = _interopRequireDefault(require("./ProductListItemCardAddToCartButton"));

var _ProductListItemCardActions = _interopRequireDefault(require("./ProductListItemCardActions"));

var _ProductListItemCardProductPrice = _interopRequireDefault(require("./ProductListItemCardProductPrice"));

var _ProductListItemCardAvailabilityFieldPreview = _interopRequireDefault(require("./ProductListItemCardAvailabilityFieldPreview"));

var _getDeliveryInfo = _interopRequireDefault(require("./getDeliveryInfo"));

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      width: '100%',
      minWidth: 130,
      border: '1px solid rgba(0,0,0,.05)',
      alignItems: 'stretch',
      alignSelf: 'stretch',
      padding: theme.spacing(1),
      gridTemplateAreas: "\n      \"image\"\n      \"title\"\n      \"price\"\n      \"addToCart\"\n      ",
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto 45px auto auto'
    }, theme.breakpoints.up('sm'), {
      gridTemplateAreas: "\n        \"image        image         image        image\"\n        \"title        title         title        title\"\n        \"description  description   description  description\"\n        \"price        price         price        price\"\n        \"actions      addToCart     addToCart    addToCart\"\n        \"storage      storage       storage      storage\"\n        ",
      gridTemplateColumns: '1fr 1fr 1fr 1fr',
      gridTemplateRows: 'auto 65px 1fr auto 45px 44px',
      width: '100%',
      padding: theme.spacing(2),
      minWidth: 260
    }),
    icon: {
      fill: theme.palette.common.black
    },
    availability: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    iconContainer: {
      padding: 0,
      height: 48,
      width: 48
    },
    detailLink: (0, _defineProperty2.default)({
      fontSize: 12
    }, theme.breakpoints.up('sm'), {
      fontSize: 18
    }),
    productName: {
      overflow: 'hidden'
    },
    image: (0, _defineProperty2.default)({
      width: 128,
      height: 'auto'
    }, theme.breakpoints.up('sm'), {
      width: 256,
      height: 192
    })
  };
}, {
  name: 'ProductListItemCard'
});
var notAvailable = {
  available: false,
  warehouse: undefined,
  quantity: 0,
  timing: undefined
};

function ProductListItemCard(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "currency", "product"]);
  var classes = useStyles({
    className: className,
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var theme = (0, _useTheme.default)();
  var notMobile = (0, _useMediaQuery.default)(theme.breakpoints.up('sm'));
  var stockQuantity = product.stockQuantity;
  var calculateProductPrice = (0, _useCalculateProductPriceHandler.default)(null);

  var _React$useState = _react.default.useState(undefined),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      prices = _React$useState2[0],
      setPrices = _React$useState2[1];

  var priceIsRelevant = Boolean(prices && prices.price && prices.priceWithTax) && prices.price > 0 && prices.priceWithTax > 0;
  var delInfo = priceIsRelevant ? (0, _getDeliveryInfo.default)(stockQuantity) : notAvailable;

  var handleScrollToTop = function handleScrollToTop() {
    return typeof window !== 'undefined' ? window.scrollTo({
      top: 0
    }) : null;
  };

  _react.default.useEffect(function () {
    calculateProductPrice(product).then(setPrices);
  }, [calculateProductPrice, product]);

  return /*#__PURE__*/_react.default.createElement(_ProductListItemCard.default, (0, _extends2.default)({}, rest, {
    classes: {
      root: classes.root
    }
  }), /*#__PURE__*/_react.default.createElement(_ProductListItemImage.default, {
    onClick: handleScrollToTop,
    product: product,
    view: 'card',
    size: "big",
    ProductImageProps: {
      classes: {
        image: classes.image
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_ProductListItemDetailLink.default, {
    onClick: handleScrollToTop,
    href: product.href,
    classes: {
      link: classes.detailLink
    },
    className: classes.productName
  }, t(product.name)), notMobile && /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, {
    renderToGridArea: 'description',
    className: classes.overflow
  }, product.description && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, t(product.description).slice(0, 90), "...")), /*#__PURE__*/_react.default.createElement(_ProductListItemCardActions.default, {
    product: product
  }), prices && /*#__PURE__*/_react.default.createElement(_ProductListItemCardProductPrice.default, {
    product: product,
    currency: currency,
    prices: prices
  }), /*#__PURE__*/_react.default.createElement(_ProductListItemCardAddToCartButton.default, {
    available: Boolean(delInfo.warehouse),
    redirectToDetail: true,
    product: product
  }), notMobile && /*#__PURE__*/_react.default.createElement(_ProductListItemCardAvailabilityFieldPreview.default, {
    renderToGridArea: 'storage',
    className: classes.availability,
    delInfo: delInfo,
    product: product
  }));
}

process.env.NODE_ENV !== "production" ? ProductListItemCard.propTypes = {
  classes: _propTypes.default.shape({
    availability: _propTypes.default.string,
    detailLink: _propTypes.default.string,
    icon: _propTypes.default.string,
    iconContainer: _propTypes.default.string,
    image: _propTypes.default.string,
    overflow: _propTypes.default.string,
    productName: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  product: _propTypes.default.shape({
    description: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    href: _propTypes.default.string,
    id: _propTypes.default.string,
    name: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    stockQuantity: _propTypes.default.shape({
      available: _propTypes.default.bool
    })
  }).isRequired
} : void 0;
ProductListItemCard.defaultProps = {
  classes: undefined,
  className: undefined,
  currency: undefined
};
var _default = ProductListItemCard;
exports.default = _default;